import React from 'react';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Alert, Spin } from 'antd';
import { Box, Text } from '../../shared/components/index';
import { fetchEncargoAndLoadIntoWorkspace, cobrarEncargosRequest } from '../../../state/actions/creators/encargos.actioncreator';
import LoadingWorkspaceSkeleton from '../components/dataDisplay/LoadingWorkspaceSkeleton.datadisplay';
import BarraSuperiorAccionesEncargo from '../containers/BarraSuperiorAccionesEncargo.general';
import DevolverModal from '../containers/DevolverModal';
import { obtenerEstadoRequestDesdeSaga } from '../../../helpers/sagaStatus.helper';
import Page from '../../shared/components/layout/Page.layout';
import EncargoCard from '../components/dataEntry/EncargoCard.dataentry';
import history from '../../../history';

class EncargosMostrar extends React.Component {
  constructor() {
    super();
    this.state = {
      modalDevolucionVisible: false,
    };
  }

  componentDidMount() {
    const { fetchEncargoAndLoadIntoWorkspace, match: { params: { encargoId, tiendaId } } } = this.props;
    fetchEncargoAndLoadIntoWorkspace(encargoId, tiendaId);
  }

  componentDidUpdate(prevProps) {
    const { match: { params: { encargoId, tiendaId } }, fetchEncargoAndLoadIntoWorkspace } = this.props;
    const { match: { params: { encargoId: previousEncargoId } } } = prevProps;
    if (encargoId !== previousEncargoId) {
      fetchEncargoAndLoadIntoWorkspace(encargoId, tiendaId);
    }
  }

  mostrarModalDevolucion = () => {
    this.setState({
      modalDevolucionVisible: true,
    });
  };

  ocultarModalDevolucion = () => {
    this.setState({
      modalDevolucionVisible: false,
    });
  };

  onDevolver = () => {
    this.setState({
      modalDevolucionVisible: false,
    });
  };

  onCobrar = (payload) => {
    const { cobrarEncargosRequest } = this.props;
    cobrarEncargosRequest(payload);
  };

  renderEncargos() {
    const { encargos } = this.props;
    return encargos.map(encargo => (
      <Box key={encargo.uuid} mb="16">
        <EncargoCard
          modo="mostrar"
          onClickSeleccionarCliente={(encargoUUID) => {
            this.abrirModalSeleccionClienteParaEncargo({ encargoUUID });
          }}
          encargo={encargo}
        />
      </Box>
    ));
  }

  render() {
    const {
      tituloEspacioDeTrabajo,
      estadoPeticionObtenerEncargo,
      estadoPeticionCobrar,
      match: { params: { encargoId, tiendaId } },
      pacienteSelected
    } = this.props;
    if(!pacienteSelected){ 
      history.push('/pacientes/buscar');
      return <div></div> 
     }
    const { modalDevolucionVisible } = this.state;

    const { running: cargandoEncargo, success: encargoCargadoConExito } = estadoPeticionObtenerEncargo;
    const { running: cargandoCobrar } = estadoPeticionCobrar;
    if (encargoCargadoConExito === false) {
      return <Alert message="Ha ocurrido un problema al cargar el encargo" type="warning" />;
    }

    if (cargandoEncargo === true) {
      return <LoadingWorkspaceSkeleton />;
    }

    const AccionesEncargo = (
      <BarraSuperiorAccionesEncargo
        onDevolver={() => this.mostrarModalDevolucion()}
        encargoId={encargoId}
        tiendaId={tiendaId}
      />
    );

    const NombreEncargo = (
      <Box pb="16">
        <Text fontSize="24">{tituloEspacioDeTrabajo}</Text>
      </Box>
    );

    return (
      <Box>
        <DevolverModal
          visible={modalDevolucionVisible}
          onClose={() => this.ocultarModalDevolucion()}
          onDevolver={() => this.onDevolver()}
          encargoId={encargoId}
          tiendaId={tiendaId}

        />
        <Page
          titulo={tituloEspacioDeTrabajo}
          hasStickyActionsHeader
          navigationItems={[
            {
              node: <Text translationId="navegacion.home" />,
              link: '',
            },
            {
              node: <Text children="" upperCase={false} lowerCase={false} translationId="navegacion.pacientes" />,
              link: '/pacientes/buscar',
            },
            {
              node: <Text upperCase={false} lowerCase={false} translationId={null}>{pacienteSelected ? pacienteSelected.nombre_completo : `Ficha (${pacienteSelected.id})`}</Text>,
              link: `/pacientes/file/${pacienteSelected.id}`,
            },
            {
              node: <Text translationId="navegacion.encargos" />,
            },
          ]}
        >
          <Box>
            {
              cargandoEncargo
                ? (
                  <LoadingWorkspaceSkeleton mt={0} hidePageTitle />
                )
                : (
                  <>
                    {AccionesEncargo}
                    {this.renderEncargos()}
                  </>
                )
            }
          </Box>
        </Page>
      </Box>
    );
  }
}

EncargosMostrar.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.object,
  }).isRequired,
  fetchEncargoAndLoadIntoWorkspace: PropTypes.func.isRequired,
  encargos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
    }),
  ).isRequired,
  promocion: PropTypes.shape({
    id: PropTypes.number,
    nombre: PropTypes.string,
  }),
  resumenPrecios: PropTypes.shape({
    total: PropTypes.string,
    totalPendiente: PropTypes.string,
  }),
  tituloEspacioDeTrabajo: PropTypes.string,
};

EncargosMostrar.defaultProps = {
  promocion: null,
  resumenPrecios: {
    total: null,
    totalPendiente: null,
  },
  tituloEspacioDeTrabajo: '',
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetchEncargoAndLoadIntoWorkspace, cobrarEncargosRequest }, dispatch);
}

const mapStateToProps = (state) => {
  const {
    encargosWorkspace: {
      encargos, promocion, resumenPrecios, tituloEspacioDeTrabajo,
    },
    pacientesWorkspace: {
      pacienteSelected
    },
    sagas,
  } = state;
  return {
    encargos: encargos || [],
    promocion,
    resumenPrecios,
    tituloEspacioDeTrabajo,
    estadoPeticionCobrar: obtenerEstadoRequestDesdeSaga(sagas, 'ENCARGOS_COBRAR'),
    estadoPeticionObtenerEncargo: obtenerEstadoRequestDesdeSaga(sagas, 'ENCARGOS_OBTENER_ENCARGO_DESDE_SERVIDOR'),
    pacienteSelected
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EncargosMostrar);
